
import { Component, Mixins, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzOverlay from 'library/v4/components/OzOverlay.vue'
import OzInputDialogBox from 'library/v4/components/OzInputDialogBox.vue'

const inputDialogStore = namespace('inputDialog')

@Component({ components: { OzOverlay, OzInputDialogBox } })
export default class GlobalInputDialog extends Mixins() {
  $refs!: {
    dialogBox: OzInputDialogBox
  }

  // This component comes as a pair with vuexstore/modules/global_input_dialog.ts.
  // Items from other parts of the vuex store should be passed in as props.
  @inputDialogStore.State isOpen!: boolean
  @inputDialogStore.State iconSrc!: string | null
  @inputDialogStore.State iconAlt!: string | null
  @inputDialogStore.State title!: string
  @inputDialogStore.State inputPlaceholder!: string
  @inputDialogStore.State inputValue!: string
  @inputDialogStore.State inputType!: string
  @inputDialogStore.State inputMaxLength!: number | null
  @inputDialogStore.State submitButtonText!: string
  @inputDialogStore.State cancelButtonText!: string
  @inputDialogStore.State shouldFadeIn!: boolean
  @inputDialogStore.State submitButtonDisabled!: boolean

  @inputDialogStore.Action updateInputValue!: (value: string) => void
  @inputDialogStore.Action cancel!: () => void
  @inputDialogStore.Action submit!: () => void

  @Watch('isOpen', { immediate: true })
  respondToDialogOpened(newIsOpen: boolean): void {
    if (newIsOpen) this.$nextTick(() => this.$refs?.dialogBox?.focus())
  }
}
